import React, { Component } from 'react';
import { Navbar, Nav } from 'react-bootstrap';

class NavContent extends Component {

  render() {
    return (
      <div>
        <Navbar.Collapse>
          <Nav>
            { this.props.left }
          </Nav>
          <Nav pullRight>
            { this.props.right }
          </Nav>
        </Navbar.Collapse>
      </div>
    );
  }

}

export default NavContent;



// WEBPACK FOOTER //
// ./src/components/Navbar/NavContent.js